<template>
  <section class="printstore-menu">
    <div class="title-container">
      <h1 :style="{ color: globe.mainTitleColor }">Winkelwagen</h1>
      <p
        class="count pointer"
        :class="{ empty: totalFiles === 0 }"
        @click="startCheckout"
        :style="[
          totalFiles === 0
            ? { color: '#bbbbbb' }
            : { color: globe.mainTextColor }
        ]"
      >
        {{ totalFiles }}
      </p>
    </div>
    <button
      class="pill-button"
      :disabled="totalFiles === 0"
      @click="startCheckout"
    >
      bestellen
    </button>
  </section>
</template>

<script>
import BackToPrintStoreMixin from '@/features/printstore/BackToPrintStoreMixin'
import { EventBus, Events } from '@/eventbus/EventBus'
import InteractionMixin from '@/mixins/InteractionMixin'
import { useFileListStore } from '@/stores/FileList.store'
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'

export default {
  mixins: [BackToPrintStoreMixin, InteractionMixin],
  computed: {
    ...mapStores(usePrintStoreStore, useFileListStore),
    globe() {
      return this.rootStore.globe
    },
    count() {
      return this.printStoreStore.orderDetails.cart.length
    },
    totalFiles() {
      return (
        this.fileListStore.fileList.length +
        this.printStoreStore.orderDetails.cart.length
      )
    }
  },
  methods: {
    startCheckout() {
      this.goToCart()
    },
    goToCart() {
      this.printStoreStore.setRouteBeforeCheckout(this.$router.currentRoute)

      const printOrder = this.rootStore.interactions.find(
        (ia) => ia.destination === 'printOrder'
      )

      /*       if (!printOrder) {
        this.$router.push({ name: 'printOrder' })
      } else { */
      this.startInteraction(printOrder)
      //    }

      EventBus.off(Events.LOGGED_IN, this.goToCart)
    },
    clear() {
      this.printStoreStore.emptyCart()
    }
  }
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 14px;
  padding-top: 19px;
  line-height: 19px;
  margin-bottom: 3px;
  font-weight: 400;
}

.printstore-menu {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  padding-top: 15px;
}

.count {
  font-size: 110px;
  line-height: 117px;
  margin-bottom: 10px;

  &.empty {
    cursor: default;
  }
}
</style>
